import Country, { type CountryFieldProps } from '../../../components/fields/CountryField';
import SelectField from './SelectField';

const CountryField = (props: CountryFieldProps) => <Country SelectComp={SelectField} {...props} />;

export default CountryField;
